import { identifier, list, object } from 'serializr';
import { createModelSchema } from '@services/EntityCache';
import type { IPrice } from '@type/IPrice';
import type { DizraptorIdeaInvestmentAvailability } from '@gql/types.generated';
import { IdeaBankDetails, IIdeaBankDetails } from './IdeaBankDetails';
import { Price } from './Price';
import { Money } from './Money';
import type { IMoney } from '../types/IMoney';

export interface IIdea {
  id: number;
  name: string;
  logoUrl: string;
  hintPaidText: string;
  hintUnpaidText: string;
  prices: IPrice[];
  investmentAvailability: DizraptorIdeaInvestmentAvailability;
  bankDetails: IIdeaBankDetails;
  minAmount: IMoney;
}

export class Idea implements IIdea {
  id!: number;

  name!: string;

  logoUrl!: string;

  hintPaidText!: string;

  hintUnpaidText!: string;

  prices!: IPrice[];

  investmentAvailability!: DizraptorIdeaInvestmentAvailability;

  bankDetails!: IIdeaBankDetails;

  minAmount!: IMoney;
}

export const ideaSchema = createModelSchema(Idea, {
  id: identifier(),
  name: true,
  logoUrl: true,
  hintPaidText: true,
  hintUnpaidText: true,
  prices: list(object(Price)),
  investmentAvailability: true,
  bankDetails: object(IdeaBankDetails),
  minAmount: object(Money)
});
